import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_b2rsmv9db5: FaireBrandEntity = {
  token: "b_b2rsmv9db5",
  type: "brand",
  name: "Alive Herbals",
  avatarUrl:
    "https://cdn.faire.com/fastly/ebaf78b476a28c43465116ea8130144f56424f4715362ddc42552d0bb79007a1.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/30e1ad9b927295e27dc50de9f79bddadce11c8b1803ff11febbb7866dd98bd4b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/ebaf78b476a28c43465116ea8130144f56424f4715362ddc42552d0bb79007a1.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/30e1ad9b927295e27dc50de9f79bddadce11c8b1803ff11febbb7866dd98bd4b.png",
  location: "New York, NY, USA",
  minimumOrderDollars: 100,
  rating: 4.4,
  reviewCount: 9,
  isInsider: true,
  description:
    "The best online natural herbal store in the USA is Alive Herbals. Discover different fresh spices, dried herbs, black seed oil and more at the best online spice store in NYC. You can buy all of these products at an affordable price at the natural foods store online. Fast and free shipping is available. Enyoy shopping with Alive Herbals.",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:51.097Z",
    importedBy: "entity-db-cli",
  },
};
